import { Box, Typography } from "@mui/material";
import { PropsWithChildren } from "react";

type Props = { title: string };

const SectionHeader: React.FC<PropsWithChildren<Props>> = (props) => {
  const { title, children } = props;

  return (
    <Box
      sx={{
        mx: 1,
        mb: 0.5,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "end",
      }}
    >
      <Typography variant="h2" fontSize={"1.5rem"} fontWeight={"bold"}>
        {title}
      </Typography>

      <Box>{children}</Box>
    </Box>
  );
};

export default SectionHeader;
